import Phaser from 'phaser';

export default class MainMenu extends Phaser.Scene {
    constructor() {
        super('mainmenu');
    }

    init() {
        //Init necessary data(User, etc.)
    }

    create() {
        var self = this;

        //Create sounds
        this.music = this.sound.add('opening', { loop: true });
        this.sfx = this.sound.add('pointSfx');
        this.music.play();


        this.bg = this.add.image(400, 800, 'bg', 'BG-title');

        let logo = this.add.image(400, 300, 'ui', 'title').setScale(0.1);

        this.logoTween = this.tweens.add({
            targets: logo,
            scale: 1,
            duration: 200,
            ease: 'Linear',
            delay: 0,
            onComplete: function() {
                self.addButtons();
                self.sfx.play();
            }
        });

        this.muteButton = this.add.sprite(730, 70, 'ui', 'unmute-button').setDepth(2);
        this.muteButton.setInteractive().on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, function() {
            self.muteButton.setScale(1);
            self.mute();
        });

        this.muteButton.on('pointerover', function() {
            self.muteButton.setScale(1.2);
        });
        this.muteButton.on('pointerout', function() {
            self.muteButton.setScale(1);
        });

    }

    mute() {
        this.sound.mute = !this.sound.mute;
        if (!this.sound.mute) {
            this.muteButton.setTexture('ui', 'mute-button');
        }
        if (this.sound.mute) {
            this.muteButton.setTexture('ui', 'unmute-button');
        }
    }

    //Add UI buttons
    addButtons() {
        var self = this;
        let playButton = this.add.sprite(0, 0, 'ui', 'button-play');

        playButton.setInteractive().on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, function() {
            self.music.stop();
            playButton.setScale(1);
            self.scene.start('game');
        });
        playButton.on('pointerover', function() {
            playButton.setScale(1.2);
        });
        playButton.on('pointerout', function() {
            playButton.setScale(1);
        });

        let guideButton = this.add.sprite(0, 0, 'ui', 'button-tutorial');

        //Add function to open guide menu
        guideButton.setInteractive().on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, function() {
            guideButton.setScale(1);
            self.scene.pause('mainmenu');
            self.scene.launch('guide');
        });
        guideButton.on('pointerover', function() {
            guideButton.setScale(1.2);
        });
        guideButton.on('pointerout', function() {
            guideButton.setScale(1);
        });

        //Align UI
        Phaser.Display.Align.In.Center(playButton, self.bg, 0, 470);
        Phaser.Display.Align.In.Center(guideButton, self.bg, 0, 590);
    }
}